import config from '../../../config';
import React, { useState } from 'react';
import { Button, Modal, ModalBody, ModalHeader } from 'reactstrap';

export const Max_Record_MOdal = () => {

    const [modal_standard, setmodal_standard] = useState(false);
    function tog_standard() {
        setmodal_standard(!modal_standard);
    }

  return (
    <>
         <span color="secondary" onClick={() => tog_standard()} style={{ backgroundColor: 'transparent', border: 'none', padding: '0px', fontSize: '18px', cursor: 'pointer'}}><i className="ri-question-line"></i></span>
      
       {/* Default Modal */}
       <Modal id="myModal"
                isOpen={modal_standard}
                toggle={() => {
                    tog_standard();
                }}
            >
                <ModalHeader className="modal-title"
                    id="myModalLabel" toggle={() => {
                        tog_standard();
                    }}>
                        Max Record
                </ModalHeader>
                <ModalBody>
                <p>{config.tool_tip.max_record}</p>
                    
                </ModalBody>
                
            </Modal>
    </>
  )
}
